import { IonButton, IonButtons, IonHeader, IonIcon, IonModal, IonTitle } from '@ionic/react';
import { arrowBack, arrowForwardOutline, checkmarkOutline, closeOutline, lockClosedOutline, shieldCheckmarkOutline } from 'ionicons/icons';
import React from 'react';
import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import PINInput from './PINInput';
import './CriarPinModal.css';

type Props = {
  mode?: 'create' | 'update';
  onClose?: () => void;
  onPinComplete?: (value: string) => void;
  onConfirmComplete?: (value: string) => void;
  isOpen: boolean;
  step: number;
  error: boolean;
  busy: boolean;
  onDidDismiss: () => void;
  onBack: () => void;
  onPinChange: (value: string) => void;
  onConfirmChange: (value: string) => void;
  onNext: () => void;
  onSave: () => void;
};

export default function CriarPinModal({ mode = 'create', onClose, onPinComplete, onConfirmComplete, isOpen, step, error, busy, onDidDismiss, onBack, onPinChange, onConfirmChange, onNext, onSave }: Props) {
  const confirming = step === 2;
  const updating = mode === 'update';
  return <IonModal className="create-pin-modal" isOpen={isOpen} backdropDismiss={updating} onDidDismiss={onDidDismiss}>
    <div className="create-pin-panel">
      <IonHeader className="ion-no-border">
        <IonToolbar>
          {confirming && !updating && <IonButtons slot="start">
            <IonButton data-modal-navigation="previous" aria-label="Voltar para criar PIN" disabled={busy} onClick={onBack}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
          </IonButtons>}
          <IonTitle>{confirming ? 'Confirmar PIN' : updating ? 'Atualize seu PIN' : 'Criar PIN de acesso'}</IonTitle>
          {updating && <IonButtons slot="end">
            <IonButton aria-label="Fechar" onClick={onClose}><IonIcon slot="icon-only" icon={closeOutline} /></IonButton>
          </IonButtons>}
        </IonToolbar>
      </IonHeader>
      <div className="create-pin-body">
        <span className="create-pin-icon"><IonIcon icon={confirming ? shieldCheckmarkOutline : lockClosedOutline} aria-hidden="true" /></span>
        <p className="create-pin-step">Etapa {confirming ? '2' : '1'} de 2</p>
        <h2>{confirming ? 'Confirme seu PIN' : updating ? 'Atualize seu PIN' : 'Configure seu PIN'}</h2>
        <p className="create-pin-description">{confirming ? 'Digite novamente os 4 dígitos para confirmar.' : 'Crie um PIN de 4 dígitos para facilitar seu próximo acesso ao sistema.'}</p>
        <div className="create-pin-fields">
          <PINInput
            key={step}
            className="create-pin-input"
            length={4}
            error={confirming && error}
            idPrefix={confirming ? 'confirm-pin-input' : 'pin-input'}
            onChange={confirming ? onConfirmChange : onPinChange}
            onComplete={confirming ? onConfirmComplete : onPinComplete}
          />
          {confirming && error && <p className="create-pin-error" role="alert">Os PINs não conferem. Digite novamente.</p>}
        </div>
        <div className="create-pin-hint">
          <IonIcon icon={shieldCheckmarkOutline} aria-hidden="true" />
          <p>{confirming ? 'Seu PIN será usado nos próximos acessos ao Xeguei.' : 'Use um PIN fácil de lembrar. Evite números em sequência ou quatro dígitos iguais.'}</p>
        </div>
      </div>
      <footer className="create-pin-footer">
        <IonButton expand="block" disabled={busy} onClick={confirming ? onSave : onNext}>
          {busy ? 'Salvando…' : confirming ? (updating ? 'Salvar' : 'Salvar PIN') : 'Avançar'}
          <IonIcon slot="end" icon={confirming ? checkmarkOutline : arrowForwardOutline} aria-hidden="true" />
        </IonButton>
      </footer>
    </div>
  </IonModal>;
}
